import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITestExplorerFilterState = ( createDecorator('testingFilterState'));
export { ITestExplorerFilterState };
